"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthCheck = void 0;
var _react = require("react");
var _toolkit = require("@reduxjs/toolkit");
var _reactRedux = require("react-redux");
var _useLogout = require("./use-logout");
/**
 * React hook to check access token validation. This should be one of the first actions the app should do to see
 * if the user is authenticated.
 */
const useAuthCheck = _ref => {
  let {
    oauthApi,
    resetUserData,
    usersApi
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const [logout] = (0, _useLogout.useLogout)({
    oauthApi,
    resetUserData,
    usersApi
  });
  const {
    isLoggedIn
  } = (0, _reactRedux.useSelector)(state => state.user);
  (0, _react.useEffect)(() => {
    if (isLoggedIn) {
      dispatch(usersApi.endpoints.getUserInfo.initiate(undefined, {
        forceRefetch: true
      })).then(_toolkit.unwrapResult).catch(error => {
        var _error$data;
        if ((error === null || error === void 0 ? void 0 : (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.error) !== 'internal_server') {
          logout();
        }
      });
    }
  }, [isLoggedIn]); // eslint-disable-line react-hooks/exhaustive-deps

  return [];
};
exports.useAuthCheck = useAuthCheck;